// Onboarding.tsx
import { AppBar } from "@mui/material";
import React from "react";

import { useOnboardingLogic } from "../Logic/OnboardingLogic";
import OnboardingUI from "../UI/onboardingUI";

import LoadingPage from "./LoadingPage";

const OnboardingMain: React.FC = () => {
  const {
    activeStep,
    steps,
    contentVisible,
    fadeDuration,
    handleNext,
    handleBack,
    loading,
    loadingText,
    stepIsValid,
    validationErrors,
  } = useOnboardingLogic();

  if (loading) {
    return <LoadingPage whatToSay={loadingText} />;
  }

  return (
    <OnboardingUI
      isStepValid={stepIsValid}
      activeStep={activeStep}
      steps={steps}
      contentVisible={contentVisible}
      fadeDuration={fadeDuration}
      handleNext={handleNext}
      handleBack={handleBack}
      validationErrors={validationErrors}
    />
  );
};

export default OnboardingMain;
